export class PHPContext
{
  path:string;
  token:string;
}